import React from 'react';
import { DModal } from '../../../../../dum';
import { OrderRequestIcon } from '../../../../icons';
import { OrderRequestStatusChangeForm } from './order-request-status-change-form';

interface ISUpdateOrderRequestStatusDialogProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    orderRequestId: number | null;
    currentStatusId?: number | null;
}

export function SUpdateOrderRequestStatusDialog({
    open,
    setOpen,
    orderRequestId,
    currentStatusId,
}: ISUpdateOrderRequestStatusDialogProps) {
    return (
        <DModal
            icon={<OrderRequestIcon />}
            title={'Cambiar status del pedido'}
            open={open}
            setOpen={setOpen}
        >
            {orderRequestId ? (
                <OrderRequestStatusChangeForm
                    orderRequestId={orderRequestId}
                    currentStatusId={currentStatusId}
                    onSuccess={() => setOpen(false)}
                />
            ) : null}
        </DModal>
    );
}
